const initHostScrollNavbar = () => {
  //navbar appears when scrolling
  const navbarOnScroll = document.getElementById('host-onscroll-navbar');
  const mainNavbar = document.querySelector('.main-navbar');
  if(navbarOnScroll){
    const onScroll = () => {
      if (window.scrollY > 0) {
        navbarOnScroll.classList.remove('hidden');
        mainNavbar?.classList.add('sm:hidden');
      }
      else {
        navbarOnScroll.classList.add('hidden');
        mainNavbar?.classList.remove('sm:hidden');
      }
    };

    window.addEventListener('scroll', function() {
      onScroll();
    });

    onScroll();
  }
}

export { initHostScrollNavbar }
